__turbopack_context__.v({
  "avatarSkeleton": "DemoDayCardSkeleton-module-scss-module__GLYB4W__avatarSkeleton",
  "badgeSkeleton": "DemoDayCardSkeleton-module-scss-module__GLYB4W__badgeSkeleton",
  "buttonSkeleton": "DemoDayCardSkeleton-module-scss-module__GLYB4W__buttonSkeleton",
  "card": "DemoDayCardSkeleton-module-scss-module__GLYB4W__card",
  "cardContent": "DemoDayCardSkeleton-module-scss-module__GLYB4W__cardContent",
  "dateSkeleton": "DemoDayCardSkeleton-module-scss-module__GLYB4W__dateSkeleton",
  "descriptionSkeleton": "DemoDayCardSkeleton-module-scss-module__GLYB4W__descriptionSkeleton",
  "line": "DemoDayCardSkeleton-module-scss-module__GLYB4W__line",
  "lineShort": "DemoDayCardSkeleton-module-scss-module__GLYB4W__lineShort",
  "overline": "DemoDayCardSkeleton-module-scss-module__GLYB4W__overline",
  "shimmer": "DemoDayCardSkeleton-module-scss-module__GLYB4W__shimmer",
  "titleSkeleton": "DemoDayCardSkeleton-module-scss-module__GLYB4W__titleSkeleton",
});
